import makeStyles from "@material-ui/core/styles/makeStyles";
import { createStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    titleBar: {
      textAlign: "start",
      backgroundColor: "#869ac4"
    },
    inputField: {
      width: "150px",
      marginLeft: "5px"
    },
    paper: {
      width: 200,
      height: 230,
      overflow: "auto"
    },
    radioGroup: {
      display: "flex",
      flexDirection: "row",
      marginLeft: "5px"
    }
  })
);
